<mdb-form-control [formGroup]="formGroup()">
  <input mdbInput
         type="{{type()}}"
         id="{{id()}}"
         [readonly]="disabled()"
         class="form-control"
         formControlName="{{controlName()}}"
         (keydown)="type() == 'number' ? preventNonNumeric($event) : null"
         placeholder="{{placeholder() ? (placeholder()!|translate) : null}}"/>
  @if (!hideLabel()) {
    <label
      mdbLabel
      class="form-label"
      for="{{id()}}">{{ label()|translate }} @if (isRequired()) {
      <span>*</span>
    }</label>
  }

  <ng-content></ng-content>

  @if (isRequired() && control?.hasError('required') && (control?.dirty || control?.touched)) {
    <mdb-error>{{ label() | translate }} {{ "VALIDATION.IS_REQUIRED"|translate }}.</mdb-error>
  }
  @if (type() == 'email' && control?.hasError('email') && (control?.dirty || control?.touched)) {
    <mdb-error>{{ label() | translate }} {{ "VALIDATION.IS_INVALID"|translate }}.</mdb-error>
  }
  @if (minLength() && control?.hasError('minlength') && (control?.dirty || control?.touched)) {
    <mdb-error>{{ label() | translate }} {{ "VALIDATION.MIN_LENGTH"|translate:{minLength: minLength()} }}.</mdb-error>
  }
  @if (min() != undefined && control?.hasError('min') && (control?.dirty || control?.touched)) {
    <mdb-error>{{ label() | translate }} {{ "VALIDATION.MIN"|translate:{min: min()} }}.</mdb-error>
  }
  @if (max() != undefined && control?.hasError('max') && (control?.dirty || control?.touched)) {
    <mdb-error>{{ label() | translate }} {{ "VALIDATION.MAX"|translate:{max: max()} }}.</mdb-error>
  }
</mdb-form-control>
